export default {
    namespaced: true,

    state: {
        currency_balance_owing_in_cents: 0,
        transaction_date: '',
        bill_to_entity_id: null,
        currency_id: null,
        // The memo trio the invoice page's Refund dialogue hands to the
        // credit-memo create page, and the invoice it was captured for. The
        // route guard on `:id/create-credit-memo` lets the page open only when
        // `action` is set AND `invoice_id` matches the route's `:id`, so a trio
        // captured for one invoice can never dress another.
        action: '',
        notes: '',
        issue_credit: null,
        invoice_id: null,
    },

    mutations: {
        setData(state, data) {
            state.bill_to_entity_id = data.bill_to_entity_id;
            state.currency_balance_owing_in_cents = data.currency_balance_owing_in_cents;
            state.transaction_date = data.transaction_date;
            state.currency_id = data.currency_id;
        },

        setMemoData(state, data) {
            state.issue_credit = data.issue_credit ?? null;
            state.notes = data.reason_for_voiding ?? data.reason_for_refunding;
            state.action = data.action;
            state.invoice_id = data.invoice_id;
            // state.reason_for_voiding = data.reason_for_voiding;
            // state.reason_for_refunding = data.reason_for_refunding;
        },

        clearMemoData(state) {
            state.issue_credit = null;
            state.notes = '';
            state.action = '';
            state.invoice_id = null;
        },

        reset(state) {
            state.currency_balance_owing_in_cents = 0;
            state.transaction_date = '';
        },
    },
};
